import angular from 'angular';
import footerTemplate from './footer.pug';

export class FooterComponent {
  constructor() {
    this.date = new Date();
  }
}

FooterComponent.$inject = [];

export default angular.module('directives.footer', [])
  .component('footer', {
    template: footerTemplate,
    controller: FooterComponent,
    controllerAs: 'fvm'
  })
  .name;
